export const SOFT_REMINDER_MAX_STEPS = 5
export const SOFT_REMINDER_MIN_DAYS = 1
export const SOFT_REMINDER_MAX_DAYS = 90
